<template>
  <div id="presentation">
    <Navbar></Navbar>
    <!-- POINT VIEW -->
    <ExplorationPoint :presentationMode="true" :exploration="exploration" :point="point"></ExplorationPoint>

    <div class="presentation-controls" v-if="currentUser != null && currentUser.uid == exploration.userId">
      <button v-if="exploration.presentation.point > 0" @click="prevPoint()" class="btn btn-primary btn-lg mr-2"><i class="fal fa-arrow-left"></i></button>
      <button v-if="exploration.presentation.point == 0" class="btn btn-primary btn-lg mr-2" disabled><i class="fal fa-arrow-left"></i></button>
      <button v-if="exploration.presentation.point < (exploration.points.length - 1)" @click="nextPoint()" class="btn btn-primary btn-lg mr-2"><i class="fal fa-arrow-right"></i></button>
      <button v-if="exploration.presentation.point == (exploration.points.length - 1)" class="btn btn-primary btn-lg mr-2" disabled><i class="fal fa-arrow-right"></i></button>
      <button @click="resetPresentation()" class="btn btn-warning btn-lg mr-2"><i class="fal fa-sync"></i></button>
      <button @click="showQR = true" class="btn btn-warning btn-lg mr-2"><i class="far fa-qrcode"></i></button>
      <button @click="showJumpMenu = true" class="btn btn-warning btn-lg mr-2"><i class="fal fa-list-ul"></i></button>
      <!-- QR CODE PANEL -->
      <div v-if="showQR == true" class="qr-code-panel">
        <button @click="showQR = false" class="btn btn-warning mt-1 float-right">Close <i class="fal fa-times"></i></button>
        <qrcode-vue class="mt-5" :value="'https://exploration.orbitist.com/presentation/' + this.exploration.id" size="500"></qrcode-vue>
      </div><!-- qr-code-panel -->
      <!-- JUMP MENU -->
      <div v-if="showJumpMenu == true" class="jump-menu-panel ml-2">
        <div class="jump-menu-panel-header">
          <button @click="showJumpMenu = false" class="btn btn-warning mt-1 float-right">Close <i class="fal fa-times"></i></button>
          <h2>Jump to point</h2>
        </div>
        <div class="jump-menu-panel-body">
          <div v-for="(point, index) in exploration.points" class="card clickable mt-2">
            <div class="card-body" @click="goToPoint(index)"><span v-if="index == exploration.presentation.point"><i class="fas fa-star text-success"></i>&nbsp;</span>{{ point.title }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
const fb = require('../firebaseConfig.js')
import Navbar from './Navbar.vue'
import ExplorationPoint from './ExplorationPoint.vue'
import QrcodeVue from 'qrcode.vue'

export default {
  data() {
    return {
      exploration: {},
      point: {},
      showQR: false,
      showJumpMenu: false
    }
  },
  computed: {
    ...mapState(['userProfile', 'currentUser'])
  },
  components: {
    Navbar,
    ExplorationPoint,
    QrcodeVue
  },
  created() {
    this.getExploration(this.$route.params.id)
    // Listen for left and right arrow
    document.onkeydown = checkKey
    let self = this
    function checkKey(e) {
      e = e || window.event
      if (e.keyCode == '37') {
        // left arrow
        self.prevPoint()
      }
      else if (e.keyCode == '39') {
        // right arrow
        self.nextPoint()
      }
    }
  },
  methods: {
    goToPoint(index) {
      fb.explorationsCollection.doc(this.exploration.id).update({
        presentation: {point: index}
      })
    },
    nextPoint() {
      let currentPoint = this.exploration.presentation.point
      let newPoint = currentPoint + 1
      fb.explorationsCollection.doc(this.exploration.id).update({
        presentation: {point: newPoint}
      })
    },
    prevPoint() {
      let currentPoint = this.exploration.presentation.point
      let newPoint = currentPoint - 1
      fb.explorationsCollection.doc(this.exploration.id).update({
        presentation: {point: newPoint}
      })
    },
    resetPresentation() {
      fb.explorationsCollection.doc(this.exploration.id).update({
        presentation: {point: 0}
      })
    },
    getExploration(id) {
      fb.explorationsCollection.doc(id).onSnapshot(doc => {
        let exploration = doc.data()
        exploration.id = doc.id
        this.exploration = exploration
        let currentUserId = 0
        if (this.currentUser != null) {
          currentUserId = this.currentUser.uid
        }
        if (exploration.points[exploration.presentation.point].private != true || currentUserId == exploration.userId) {
          this.point = exploration.points[exploration.presentation.point]
        } else {
          this.point = {}
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Presentation.vue